/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import ReceiverAction from "../action/ReceiverAction"

export const initialState = ({
    loading: false,
    receiverList: null,    
    receiver: null,
})
  
export default function (state = initialState, action) {
    switch (action.type) {
  
      case ReceiverAction.TYPES.REQUEST_RECEIVER_LIST:
        return Object.assign({}, state, { receiverList: null, loading: true})
  
      case ReceiverAction.TYPES.REQUEST_RECEIVER_LIST_SUCCESS:
        return Object.assign({}, state, { receiverList: action.payload, loading: false})

      case ReceiverAction.TYPES.REQUEST_RECEIVER_DETAIL_SUCCESS:
        return Object.assign({}, state, { receiver: action.payload.data, loading: false})

      case ReceiverAction.TYPES.REQUEST_CREATE_RECEIVER_SUCCESS: {
          const newList = state.receiverList
          newList.data = newList.data.reverse()
          newList.data.push(action.payload.data)
          newList.data = newList.data.reverse()
          return Object.assign({}, state, { receiverList: newList, loading: false})
      }        
  
      case ReceiverAction.TYPES.REQUEST_UPDATE_RECEIVER_SUCCESS: {
        const newList = state.receiverList
        newList.data = newList.data.map(item => {
          if(item.id == action.payload.data.id) {
            return action.payload.data
          }
          return item
        })
        return Object.assign({}, state, { receiverList: newList, loading: false})
      }        
  
      default:
        return state
    }
}



  